$('.socialproofbanner__logos').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
  touchThreshold: 100,
  speed: 480,
  pauseOnHover: false,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
})
